/**
 * Development-only logger. All calls are stripped from production builds
 * because Vite replaces `import.meta.env.DEV` with `false` and tree-shaking
 * removes the dead code.
 */
const isDev = import.meta.env.DEV

/* eslint-disable no-console */
export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log('[GIM]', ...args)
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn('[GIM]', ...args)
  },
  error: (...args: unknown[]) => {
    if (isDev) console.error('[GIM]', ...args)
  },
}
/* eslint-enable no-console */
